"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const lodash_1 = require("lodash");
const react_1 = __importDefault(require("react"));
const Checkbox_pc_1 = require("./Checkbox.pc");
const Toggle_pc_1 = require("./Toggle.pc");
const Checkbox = ({ secondary = false, id, value = false, disabled = false, onValueChange = lodash_1.noop, testId, }) => {
    const onClick = () => onValueChange(!value);
    // onChange irelevant here since change events are handle by
    // onClick
    const onChange = lodash_1.noop;
    if (secondary) {
        return react_1.default.createElement(Toggle_pc_1.StyledToggle, { on: value, onClick: onClick });
    }
    return (react_1.default.createElement(Checkbox_pc_1.Checkbox, { id: id, testId: testId, onClick: onClick, checked: value, disabled: disabled, onChange: onChange }));
};
exports.Checkbox = Checkbox;
//# sourceMappingURL=Checkbox.js.map